import { Controller } from "@/controllers/Controller";

/**
 * Controller for French Directory Cache API
 */
export class InvoiceTransmissionAssociationController extends Controller {

    static refreshIncomingInvoices() {
        return this.requestBuilder("POST", `/ms-transmission/invoice-transmission-association/refresh/incoming-invoices/`, true);
    }

    static refreshStatuses() {
        return this.requestBuilder("POST", `/ms-transmission/invoice-transmission-association/refresh/statuses/`, true);
    }

    static getIncomingInvoiceAssociationTable(params = "") {
        return this.requestBuilder("GET", `/ms-transmission/invoice-transmission-association/table/incoming-invoice-association${params}`, true);
    }

    static getOutgoingInvoiceAssociationTable(params = "") {
        return this.requestBuilder("GET", `/ms-transmission/invoice-transmission-association/table/outgoing-invoice-association${params}`, true);
    }

    static async getAvailableStatusTransitions(associationId) {
        return this.requestBuilder("GET", `/ms-transmission/invoice-transmission-association/available-status-transitions/${associationId}`, true);
    }

    static async updateInvoiceStatus(associationId, status) {
        return this.requestBuilder("POST", `/ms-transmission/invoice-transmission-association/invoice-status/?associationId=${associationId}&status=${status}`, true);
    }

}